// extracted by mini-css-extract-plugin
module.exports = {"title":"_3526nD"};